<style src="./MainMenu.scss" lang="scss" scoped></style>
<template lang="html">
  <menu class="main-menu">
    <div class="logo">
      <img src="/static/logo/logo-34x50.png" alt="Sinkr Logo" />
    </div>

    <div class="user-info" @click="showUserPopup">
      <div class="user-profile-icon">
        <icon-user-profile class="icon" />
      </div>

      <div class="user-name">
        <h4>
          Olá, <span class="name">{{ username }}</span>
        </h4>
      </div>

      <div class="user-popup">
        <icon-arrow class="icon-down" />
      </div>

      <div
        class="user-popup-content"
        v-click-outside="hideUserPopup"
        v-if="userPopupShowStatus"
      >
        <ul>
          <li @click="doLogoff"><icon-power /><span>Sair</span></li>
        </ul>
      </div>
    </div>

    <div class="user-comunication">
      <div class="user-comunication-icon">
        <icon-message class="icon" />
        <span v-show="countMessages" class="menu-badge-alert">{{
          countMessages
        }}</span>
      </div>
      <div class="user-comunication-icon">
        <icon-alert-message class="icon" />
        <span v-show="countAlerts" class="menu-badge-alert">{{
          countAlerts
        }}</span>
      </div>
      <div class="user-comunication-icon">
        <icon-activity class="icon" />
      </div>
    </div>

    <div class="menu-options">
      <ul>
        <li @click="jumpToRoute('BidResume')">
          <icon-menu-dashboard :circleFill="listMenu.dashboard" />
          <h4>Dashboard</h4>
        </li>
        <li @click="jumpToRoute('Board')">
          <icon-menu-dashboard :circleFill="listMenu.board" />
          <h4>Quadro</h4>
        </li>
        <li
          @click="jumpToRoute('Event')"
          v-if="
            $store.getters['Login/HAS_PERMISSION_IN_AREA']({
              area: 'event',
              action: 'SHOW'
            })
          "
        >
          <icon-menu-event :circleFill="listMenu.event" />
          <h4>Evento</h4>
        </li>
        <li
          @click="jumpToRoute('Research')"
          v-if="
            $store.getters['Login/HAS_PERMISSION_IN_AREA']({
              area: 'record',
              action: 'SHOW'
            })
          "
        >
          <icon-menu-research :circleFill="listMenu.research" />
          <h4>Pesquisa</h4>
        </li>
        <li
          @click="jumpToRoute('Record')"
          v-if="
            $store.getters['Login/HAS_PERMISSION_IN_AREA']({
              area: 'record',
              action: 'SHOW'
            })
          "
        >
          <icon-menu-record :circleFill="listMenu.record" />
          <h4>Cadastro</h4>
        </li>
      </ul>
    </div>

    <div class="app-info">
      <span class="version">v3.6.0</span>
    </div>
  </menu>
</template>

<script>
import {
  IconUserProfile,
  IconArrow,
  IconPower,
  IconMessage,
  IconActivity,
  IconAlertMessage,
  IconMenuDashboard,
  IconMenuRecord,
  IconMenuResearch,
  IconMenuEvent
} from "@/components/primitives/icons";
import { mapGetters } from "vuex";

const DEFAULT_COLOR = "#bdcdda";
const ACTIVE_COLOR = "#497ea8";

export default {
  name: "MainMenu",
  components: {
    IconUserProfile,
    IconArrow,
    IconPower,
    IconMessage,
    IconActivity,
    IconAlertMessage,
    IconMenuDashboard,
    IconMenuRecord,
    IconMenuResearch,
    IconMenuEvent
  },
  data() {
    return {
      actualMenuActive: "welcome",
      listMenu: {
        dashboard: DEFAULT_COLOR,
        event: DEFAULT_COLOR,
        welcome: DEFAULT_COLOR,
        record: DEFAULT_COLOR,
        board: DEFAULT_COLOR
      },
      userPopupShowStatus: false
    };
  },
  computed: {
    username() {
      return this.$store.state.Login.username;
    },
    permissionRecord: function() {
      return this.$store.getters["Login/HAS_PERMISSION_IN_AREA"]({
        area: "record",
        action: "SHOW"
      });
    },
    ...mapGetters({
      countAlerts: "Realtime/COUNT_ALERTS",
      countMessages: "Realtime/COUNT_MESSAGES"
    })
  },
  watch: {
    $route: "fetchData"
  },
  mounted() {
    this.$store.dispatch("Realtime/MAP_USER");
  },
  methods: {
    jumpToRoute(pRoute) {
      this.$router.push({ name: pRoute });
    },
    fetchData() {
      for (let itemMenu in this.listMenu) {
        this.listMenu[itemMenu] = DEFAULT_COLOR;
      }
      this.listMenu[this.$route.meta.area] = ACTIVE_COLOR;
    },
    hideUserPopup() {
      this.userPopupShowStatus = false;
    },
    showUserPopup() {
      console.log("here");
      this.userPopupShowStatus = true;
    },
    doLogoff() {
      this.$store.dispatch("Login/DO_LOGOFF", this.$router);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/foundation/main-menu/MainMenu.vue